import React from 'react';
import { ButtonComponent, type ButtonComponentProps } from './ButtonComponent';

export interface SecondaryActionButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'inherit' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  sx?: ButtonComponentProps['sx'];
}

const SecondaryActionButton: React.FC<SecondaryActionButtonProps> = ({
  label,
  onClick,
  disabled = false,
  variant = 'text',
  color = 'inherit',
  size = 'medium',
  fullWidth = false,
  startIcon,
  endIcon,
  sx,
}) => {
  return (
    <ButtonComponent
      onClick={onClick}
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
       sx={{
        backgroundColor: "#ffffff",    // bg-white
        color: "#111827",              // text-gray-900
        border: "1px solid #d1d5db",   // border border-gray-300
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "#f3f4f6",  // hover:bg-gray-100
        },
        "&:focus": {
          outline: "none",
          boxShadow: "0 0 0 4px #f3f4f6", // focus:ring-4 focus:ring-gray-100
        },
        ...sx,
      }}
    >
      {label}
    </ButtonComponent>
  );
};

export default SecondaryActionButton;